export const REQUEST_PICKUPCODE = 'REQUEST_PICKUPCODE';
export const REQUEST_PICKUPCODE_SUCCESS = 'REQUEST_PICKUPCODE_SUCCESS';
export const REQUEST_PICKUPCODE_ERROR = 'REQUEST_PICKUPCODE_ERROR';
export const REQUEST_PICKUPCODE_LOADING = 'REQUEST_PICKUPCODE_LOADING';
